import React, { Component } from 'react'
import apiService from '../../services/ApiService'
import Select from 'react-select'

class BrandsByKitchen extends Component {
    constructor() {
        super()
        this.state = {
            BrandsByKitchenList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getBrandsByKitchenId(this.props.kitchen_id)
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getBrandsByKitchenId = (kitchen_id) => {
        apiService.getBrandsByKitchenId(kitchen_id)
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                    if (listData.status === "SUCCESS") {
                        this.setState({
                            BrandsByKitchenList: listData.data ? listData.data : {},
                        })
                    } else {
                        console.error("Filed response from costCenter list api")
                    }
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}
        list = Object.keys(this.state.BrandsByKitchenList).map((value,index) => {
            return {
                label : this.state.BrandsByKitchenList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));
       

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={list}
                placeholder="Select Brand"
                onChange={(e) => { (e) ? this.props.brandChange(e) : this.props.brandChange([])}}
                />
            </div>
        )
    }
}

export default BrandsByKitchen


// WEBPACK FOOTER //
// ./src/common/DropDowns/BrandsByKitchen.js